import { Box } from '#/components/Box/Box';
import { Hide } from '#/components/Hide/Hide';
import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';

type SidebarLinksProps = {
  orgUrl: string | null;
  searchContext: SearchContextHeaderData | null | undefined;
};

export function ListingViewSidebarLinks({
  orgUrl,
  searchContext,
}: SidebarLinksProps) {
  const { i18n } = useI18n();

  return (
    <Hide xs sm md>
      <Box display="flex" gridGap={3} flexDirection="column">
        {searchContext && (
          <StyledVersionedRouterLink
            to={searchContext.searchResultsUrl}
            state={searchContext.searchResultsState}
            qaId="search-context-back-to-search-sidebar"
          >
            {i18n('Back to search results')}
          </StyledVersionedRouterLink>
        )}

        {orgUrl && (
          <>
            <StyledVersionedRouterLink to={`${orgUrl}#opportunities`}>
              {i18n('See all listings from this organization')}
            </StyledVersionedRouterLink>
            <StyledVersionedRouterLink to={`${orgUrl}#about`}>
              {i18n('About this organization')}
            </StyledVersionedRouterLink>
          </>
        )}
      </Box>
    </Hide>
  );
}
